import { render } from "./applicantList.vue?vue&type=template&id=7b588bfb"
import script from "./applicantList.vue?vue&type=script&lang=js"
export * from "./applicantList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__